module.exports = __webpack_public_path__ + "6d20f4f3f930322aa707790bcd042758.png";